
import { defineComponent, inject, onUnmounted, ref } from 'vue'

export default defineComponent({
  name: 'RandselDialog',
  props: {
    title: {
      type: String,
      default: 'title'
    },
    showEventName: {
      type: String,
      required: true
    }
  },
  emits: ['onShow', 'onHide'],
  setup(props, { emit }) {
    const emitter: any = inject('emitter')
    const visible = ref(false)
    let root = ref(null)

    emitter.on(props.showEventName, show)
    emitter.on('hideDialogs', onHideDialogs)

    function show() {
      visible.value = true
      emitter.emit('showOverlay')
      document.body.classList.add('dialog-open')
      emit('onShow')
    }

    function onHideDialogs() {
      visible.value = false
      document.body.classList.remove('dialog-open')
    }

    const hideDialog = () => {
      hide()
    }

    function hide() {
      visible.value = false
      emitter.emit('hideOverlay')
      document.body.classList.remove('dialog-open')
      emit('onHide')
    }

    onUnmounted(() => {
      emitter.off(props.showEventName, show)
      emitter.off('hideDialogs', onHideDialogs)
    })

    return {
      root,
      visible,
      hideDialog
    }
  }
})
